import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatTooltip } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { ColorSchemeStore, type ColorScheme } from '../../state/ui';

@Component({
  selector: 'button[color-scheme-toggle]',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './color-toggle.component.html',
  styleUrl: './color-toggle.component.css',
  host: {
    'type': 'button',
    'class': 'btn btn-small btn-flat btn-icon',
    '(click)': 'cycle()',
    '[attr.aria-label]': 'current().label',
  },
  imports: [
    FontAwesomeModule,
  ],
  hostDirectives: [MatTooltip, MatRipple]
})
export class ColorSchemeToggleComponent {
  constructor() {
    effect(() => {
      const wasVisible = this.tooltip._isTooltipVisible();
      this.tooltip.message = this.current().label;
      if (wasVisible)
        this.tooltip.show();
    });
  }
  private readonly tooltip = inject(MatTooltip, { self: true });
  protected readonly colorScheme = inject(ColorSchemeStore);

  private readonly options: Record<ColorScheme, { label: string; icon: IconDefinition; next: ColorScheme; }> = {
    'light': { label: 'Light', icon: faSun, next: 'dark' },
    'dark': { label: 'Dark', icon: faMoon, next: 'light' }
  };

  protected readonly current = computed(() => this.options[this.colorScheme.resolved()]);

  protected cycle() {
    this.colorScheme.setPreference(this.current().next);
  }
}
